import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { List } from 'foundations-components/transitional/components/List';
import { ListItem } from 'foundations-components/transitional/components/List';
import ButtonCardAction from './ButtonCardAction';
import LinkCardAction from './LinkCardAction';
import HubSpotAppLinkCardAction from './HubSpotAppLinkCardAction';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { BUTTON, HUBSPOT_APP_LINK, LINK, ACTION_LIBRARY_BUTTON, DIVIDER } from '../../constants/CardActionType';
import ActionLibraryButtonAction from './ActionLibraryButtonAction';
import { DropdownDivider } from 'foundations-components/transitional/components/Dropdown';
import { LINK as MODE_LINK, BUTTON as MODE_BUTTON } from '../../constants/CardActionDisplayMode';
import { getTrellisIconComponent } from './CardActionIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default function DropdownAction({
  actionConfig,
  mode
}) {
  if (actionConfig.options.length === 0) {
    return null;
  }
  const dropdown = /*#__PURE__*/_jsx(Dropdown, {
    buttonSize: mode === MODE_LINK ? 'small' : 'extra-small',
    buttonText: /*#__PURE__*/_jsx("span", {
      children: actionConfig.label
    }) // span for spacing between icon and text
    ,
    icon: actionConfig.iconName ? getTrellisIconComponent(actionConfig.iconName) : undefined,
    disabled: actionConfig.disabled
    // 'link' is being used instead of 'transparent' so that the dropdown button
    // is in line with the other link-styled buttons
    ,
    buttonUse: mode === MODE_LINK ? 'link' : 'tertiary-light',
    children: /*#__PURE__*/_jsx(List, {
      children: actionConfig.options.map((option, key) => {
        if (option.type === BUTTON) {
          return /*#__PURE__*/_jsx(ListItem, {
            children: /*#__PURE__*/_jsx(ButtonCardAction, {
              actionConfig: option,
              mode: MODE_BUTTON
            })
          }, key);
        }
        if (option.type === ACTION_LIBRARY_BUTTON) {
          return /*#__PURE__*/_jsx(ListItem, {
            children: /*#__PURE__*/_jsx(ActionLibraryButtonAction, {
              actionConfig: option,
              mode: MODE_BUTTON
            })
          }, key);
        }
        if (option.type === LINK) {
          return /*#__PURE__*/_jsx(ListItem, {
            children: /*#__PURE__*/_jsx(LinkCardAction, {
              actionConfig: option,
              mode: mode
            })
          }, key);
        }
        if (option.type === HUBSPOT_APP_LINK) {
          return /*#__PURE__*/_jsx(ListItem, {
            children: /*#__PURE__*/_jsx(HubSpotAppLinkCardAction, {
              actionConfig: option,
              mode: MODE_BUTTON
            })
          }, key);
        }
        if (option.type === DIVIDER) {
          return /*#__PURE__*/_jsx(DropdownDivider, {
            role: "divider"
          }, key);
        }
        return null;
      })
    })
  });
  if (actionConfig.tooltipText) {
    return /*#__PURE__*/_jsx(Tooltip, {
      title: actionConfig.tooltipText,
      children: dropdown
    });
  }
  return dropdown;
}